export default "__VITE_ASSET__bc1fec2c__"